import { Outlet } from 'react-router-dom';
import AmicaleTopBar from './AmicaleTopBar';

const AmicaleLayout = () => {
  return (
    <div
      style={{
        minHeight: '100vh',
        background: 'var(--gray-200)',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <AmicaleTopBar />
      <main style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        <Outlet />
      </main>
    </div>
  );
};

export default AmicaleLayout;
